var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkActionFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.80369C12 3.31153 12 2.56545 11.7562 1.97693C11.4312 1.19224 10.8078 0.568804 10.0231 0.243773C9.43455 0 8.68847 0 7.19631 0H4.8037C3.31153 0 2.56545 0 1.97693 0.243773C1.19224 0.568804 0.568803 1.19224 0.243772 1.97693C-7.45058e-07 2.56545 -5.05496e-07 3.31153 1.46049e-09 4.8037L3.80956e-06 16H1.20092L6 13.0077L10.7991 16H12V4.80369Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkActionFilled);
export default __webpack_public_path__ + "static/media/bookmarkActionFilled.642f50c3fc6ac1280619840097101506.svg";
export { ForwardRef as ReactComponent };